import { useMediaQueryScales, SizeMediaScales } from './media-query';
export function useSizeMediaQuery(props) {
    if (typeof props.xsWidth !== 'undefined') {
        if (typeof props.mobileWidth === 'undefined')
            props.mobileWidth = props.xsWidth;
    }
    else if (typeof props.smWidth !== 'undefined') {
        if (typeof props.xsWidth === 'undefined')
            props.xsWidth = props.smWidth;
        if (typeof props.mobileWidth === 'undefined')
            props.mobileWidth = props.smWidth;
    }
    if (typeof props.xsMinWidth !== 'undefined') {
        if (typeof props.mobileMinWidth === 'undefined')
            props.mobileMinWidth = props.xsMinWidth;
    }
    else if (typeof props.smMinWidth !== 'undefined') {
        if (typeof props.xsMinWidth === 'undefined')
            props.xsMinWidth = props.smMinWidth;
        if (typeof props.mobileMinWidth === 'undefined')
            props.mobileMinWidth = props.smMinWidth;
    }
    if (typeof props.xsMaxWidth !== 'undefined') {
        if (typeof props.mobileMaxWidth === 'undefined')
            props.mobileMaxWidth = props.xsMaxWidth;
    }
    else if (typeof props.smMaxWidth !== 'undefined') {
        if (typeof props.xsMaxWidth === 'undefined')
            props.xsMaxWidth = props.smMaxWidth;
        if (typeof props.mobileMaxWidth === 'undefined')
            props.mobileMaxWidth = props.smMaxWidth;
    }
    if (typeof props.xsHeight !== 'undefined') {
        if (typeof props.mobileHeight === 'undefined')
            props.mobileHeight = props.xsHeight;
    }
    else if (typeof props.smHeight !== 'undefined') {
        if (typeof props.xsHeight === 'undefined')
            props.xsHeight = props.smHeight;
        if (typeof props.mobileHeight === 'undefined')
            props.mobileHeight = props.smHeight;
    }
    if (typeof props.xsMinHeight !== 'undefined') {
        if (typeof props.mobileMinHeight === 'undefined')
            props.mobileMinHeight = props.xsMinHeight;
    }
    else if (typeof props.smMinHeight !== 'undefined') {
        if (typeof props.xsMinHeight === 'undefined')
            props.xsMinHeight = props.smMinHeight;
        if (typeof props.mobileMinHeight === 'undefined')
            props.mobileMinHeight = props.smMinHeight;
    }
    if (typeof props.xsMaxHeight !== 'undefined') {
        if (typeof props.mobileMaxHeight === 'undefined')
            props.mobileMaxHeight = props.xsMaxHeight;
    }
    else if (typeof props.smMaxHeight !== 'undefined') {
        if (typeof props.xsMaxHeight === 'undefined')
            props.xsMaxHeight = props.smMaxHeight;
        if (typeof props.mobileMaxHeight === 'undefined')
            props.mobileMaxHeight = props.smMaxHeight;
    }
    var scales = useMediaQueryScales(props.useMediaQuery);
    for (var _i = 0, SizeMediaScales_1 = SizeMediaScales; _i < SizeMediaScales_1.length; _i++) {
        var scale = SizeMediaScales_1[_i];
        if (props["".concat(scale, "Width")] || props["".concat(scale, "MaxWidth")] || props["".concat(scale, "MinWidth")] || props["".concat(scale, "Height")] || props["".concat(scale, "MaxHeight")] || props["".concat(scale, "MinHeight")]) {
            if (scales[scale]) {
                if (typeof props["".concat(scale, "Width")] !== 'undefined')
                    props.width = props["".concat(scale, "Width")];
                if (typeof props["".concat(scale, "MinWidth")] !== 'undefined')
                    props.minWidth = props["".concat(scale, "MinWidth")];
                if (typeof props["".concat(scale, "MaxWidth")] !== 'undefined')
                    props.maxWidth = props["".concat(scale, "MaxWidth")];
                if (typeof props["".concat(scale, "Height")] !== 'undefined')
                    props.height = props["".concat(scale, "Height")];
                if (typeof props["".concat(scale, "MinHeight")] !== 'undefined')
                    props.minHeight = props["".concat(scale, "MinHeight")];
                if (typeof props["".concat(scale, "MaxHeight")] !== 'undefined')
                    props.maxHeight = props["".concat(scale, "MaxHeight")];
            }
        }
    }
}
